/**
 * Resolve the active AWS region in both webpack bundles and Vite development.
 *
 * @returns Active AWS region.
 */
export default function getActiveAwsRegion(): string {
	if (typeof window !== 'undefined') {
		const requestRegion = window.__CREATOR_AWS_DEFAULT_REGION__;

		if (requestRegion) {
			return requestRegion;
		}
	}

	return AWS_DEFAULT_REGION;
}
